import { CalendarEvent, CalendarEventListItem } from "../../model";
import { DatelyObject, Dates } from "../../util";
import { Ajax } from "../infra/Ajax";
import { CrudApiBase } from "../infra/CrudApiBase";

/**
 * Provides CRUD access for Calendar events and other calendar methods.
 */
export class CalendarEvents extends CrudApiBase<CalendarEvent, CalendarEventListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/calendar/events";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): CalendarEvent {
    return {
      event: {
        isAllDay: true, // By default, we have all-day events of one day.
        start: Dates.getToday(),
        end: Dates.getToday(),
        duration: "1",
        actions: [],
        attachments: [],
        attendees: [],
        categories: [],
        recurrenceRules: [],
      },
    };
  }

  /**
   * Recalculates the occurence info based on the event.
   * This is an anonymous method that does not commit anything to database.
   * @param event Calendar event to recalculate.
   * @param start Start of the period for which the events are fetched and occurences are calculated.
   * If null, period is set 1 year before today. Max history/future 3 years. Max period 24 months.
   * @param end End of the period for which the occurences are calculated.
   * @returns A Promise with result data: The calendar event with occurenceInfo recalculated.
   */
  public recalculate(event: CalendarEvent, start: DatelyObject | null = null, end: DatelyObject | null = null): Promise<CalendarEvent> {
    return this.ajax.postJSON(`${this.baseUrl}/recalculate?start=${Dates.asDate(start) || ""}&end=${Dates.asDate(end) || ""}`, event);
  }
}
